import * as React from 'react';
import { Redirect } from 'react-router';

export const devDemoPageEnabled = false;

/**
 * Production version of the dev demo page.
 * This prevents the JS/HTML for the demo page from being included in the build.
 */
export const DevDemoPage: React.FunctionComponent<{}> = (props) => {
    return <Redirect to='/' />;
};
